export const types = {
  ASSEMBLY_TREE_MARK_TREE_NEEDS_UPDATE:
    'quotes/quoteItemComponents/assemblyTree/ASSEMBLY_TREE_MARK_TREE_NEEDS_UPDATE',
};

export const assemblyTree = {
  markNeedsUpdate: ({ delayTime = 500 }) => ({
    type: types.ASSEMBLY_TREE_MARK_TREE_NEEDS_UPDATE,
    payload: { delayTime },
  }),
};
